export default "__VITE_ASSET__Bsy8qbwh__"